import { LinkVariants } from 'interfaces/shared/link.interfaces';

export const LinkVariantsStyles: { [key in LinkVariants]: string } = {
  [LinkVariants.MAIN]:
    'bg-mediumBlue border border-mediumBlue justify-center hover:text-mediumBlue hover:stroke-mediumBlue hover:fill-mediumBlue hover:bg-transparent',
  [LinkVariants.TRANSPARENT]: 'bg-transparent border-none rounded-none',
  [LinkVariants.CANCEL_OUTLINED]:
    'bg-transparent border border-red justify-center text-red hover:bg-red hover:text-white',
};
